<script lang="ts">
import { defineComponent, inject, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue';

export default defineComponent({
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: [String, Number, Array, Object],
        },
    },

    setup(props) {
        const value = ref(props.value);

        let unregister: any;

        onBeforeMount(() => {
            unregister = inject<registerFormComponentFn | null>(
                'registerFormComponent',
                null,
            )?.({
                key: props.name,
                value,
            });
        });

        onBeforeUnmount(() => {
            unregister?.();
            unregister = null;
        });

        watch(
            () => props.value,
            () => {
                value.value = props.value;
            },
        );

        return {};
    },
});
</script>
